import api from '../library/axios';
import RSA from '../library/rsa-encrypt';

export default {
  getList(page, search) {
    return api({
      method: 'get',
      url: '/api/users',
      params: {
        page,
        search,
      },
    });
  },
  createUser({
    name,
    phone_number,
    email,
    password,
    is_pic = false,
  }) {
    return api({
      method: 'post',
      url: '/api/users',
      data: {
        name,
        phone_number,
        email,
        password: RSA.encrypt(password, 'base64'),
        is_pic,
      },
    });
  },
  update(user_id, {
    name,
    email,
    is_pic,
    password,
  }) {
    return api({
      method: 'patch',
      url: `/api/users/${user_id}`,
      data: {
        name,
        email,
        is_pic,
        password,
      },
    });
  },
  delete(user_id) {
    return api({
      method: 'delete',
      url: `/api/users/${user_id}`,
    });
  },
};
